<template>
  <div class="lh-main-container clearfix">
    <div class="banner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(slide,index) in bannerList" :key="index"><a :href="slide.link" target="_blank"><img :src="slide.img"></a></swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
      <!-- <figure class="banner-bottom"><svg viewBox="0 0 2986 269" version="1.1" xmlns="http://www.w3.org/2000/svg" class="svg"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard"><path d="M0.865233065,92.4175927 C202.235515,128.155877 379.218655,168.329096 777.110311,168.329096 C1493.77698,168.329096 1493.77698,38 2210.44364,38 C2607.82383,38 2784.8633,78.0699243 2985.91247,113.773555" id="Page-1" stroke="#FFFFFF" stroke-width="17" transform="translate(1493.388851, 103.164548) scale(-1, 1) translate(-1493.388851, -103.164548) "></path> <polygon id="Rectangle" fill="#FFFFFF" points="0 113.493251 191.860455 79.3153091 353.659191 57.9412239 590.913008 37.0172742 966.102491 41.5245142 1251.83856 65.0139425 1643.63893 134.5 2119.38517 171.852006 2633.97841 150.271976 2986 94.8170373 2986 269 0 269"></polygon></g></g></svg></figure> -->
    </div>
    <div class="headline">
      <h2 class="lh-introduct">功能介绍</h2>
    </div>
    <div class="part1">
      <div class="app-container lrtotal personal-apply">
        <transition name="fade">
          <div
            class="applyImg"
            v-show="animate.part1.img"
          >
            <img
              :src="imgArr[1]"
              alt=" "
            />
          </div>
        </transition>
        <div
          class="ltotal clearfix"
          style="margin-right: 20px;"
        >
          <div class="ltotal flr">
            <transition enter-active-class="fadeInUp">
              <h2
                class="pub-ltxt1 animated"
                v-show="animate.part1.h2"
              >个性化自定义</h2>
            </transition>
            <div
              class="pub-ltxt2"
              style="height: 57px"
            >
              <transition enter-active-class="fadeInUp">
                <p
                  class="animated"
                  v-show="animate.part1.p"
                >获取用户信息个性化回复，任意跳转商城、网站、App等外部链接；突破字数限制，开启特别菜单栏。</p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg part2">
      <div class="app-container lrtotal task-cowry pub-height">
        <div
          class="ltotal clearfix ml20"
          style="height: 92px"
        >
          <transition enter-active-class="fadeInUp">
            <h2
              class="pub-ltxt1 animated"
              v-show="animate.part2.h2"
            >任务宝</h2>
          </transition>
          <div class="pub-ltxt2 ltotal">
            <transition enter-active-class="fadeInUp">
              <p
                class="animated"
                v-show="animate.part2.p"
              >可自行上传奖品，根据粉丝属性策划特定的活动，依托朋友圈实现粉丝爆炸式增长，公众号拉新必备神器。</p>
            </transition>
          </div>
        </div>
        <transition name="fade">
          <div
            class="mr20 "
            v-show="animate.part2.img"
          >
            <img
              :src="imgArr[2]"
              alt=" "
            />
          </div>
        </transition>
      </div>
    </div>
    <div class="part3">
      <div class="app-container lrtotal personal-apply">
        <transition name="fade">
          <div
            class="applyImg"
            v-show="animate.part3.img"
          >
            <img
              :src="imgArr[3]"
              alt=" "
            />
          </div>
        </transition>
        <div
          class="ltotal clearfix"
          style=" margin-right: 20px; height: 92px"
        >
          <div class="ltotal flr">
            <transition enter-active-class="fadeInUp">
              <h2
                class="pub-ltxt1 animated"
                v-show="animate.part3.h2"
              >模版群发</h2>
            </transition>
            <div class="pub-ltxt2">
              <transition enter-active-class="fadeInUp">
                <p
                  class="animated"
                  v-show="animate.part3.p"
                >高打开率，提高销售转化效率；次数无限，突破服务号每月4次限制。</p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg part4">
      <div class="app-container lrtotal task-cowry pub-height">
        <div
          class="ltotal clearfix ml20"
          style="height: 92px"
        >
          <transition enter-active-class="fadeInUp">
            <h2
              class="pub-ltxt1 animated"
              v-show="animate.part4.h2"
            >带参二维码</h2>
          </transition>
          <div class="pub-ltxt2 ltotal">
            <transition enter-active-class="fadeInUp">
              <p
                class="animated"
                v-show="animate.part4.p"
              >有效获取用户行为数据，评估渠道效果，便于及时调整营销策略。</p>
            </transition>
          </div>
        </div>
        <transition name="fade">
          <div
            class="mr20"
            v-show="animate.part4.img"
          >
            <img
              :src="imgArr[4]"
              alt=" "
            />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mainContainer',
  data () {
    return {
      imgArr: [
        './static/image/1.png',
        './static/image/2.png',
        './static/image/3.png',
        './static/image/4.png',
        './static/image/5.png'
      ],
      /**
       * banner轮播
       */
      bannerDesk: [
        {
          link: 'https://lh.playhudong.com/#/register',
          img: './static/image/lh-banner-zhangfen.jpg'
        },
        {
          link: 'https://mp.weixin.qq.com/s/ssTbJUZOPnqUIHIJDZOfzQ',
          img: './static/image/lh-banner-jiafen.jpg'
          // link: 'https://mp.weixin.qq.com/s?__biz=MzA3NzQ1MjI4OQ==&mid=2457376064&idx=1&sn=ab54e1157fefa603c7d60914e39dba72&chksm=88ddf02ebfaa79387928b5953dfbb69ee7dc5d9695004aa6b9c56af916eed7bc27601f97151d&token=672966186&lang=zh_CN#rd',
          // img: './static/image/2019219banner.gif'
        }
      ],
      /**
      * banner轮播移动端
      */
      bannerMobile: [
        {
          link: 'https://lh.playhudong.com/#/register',
          img: './static/image/mobilebanner01.png'
        },
        {
          link: 'https://mp.weixin.qq.com/s/6E2wQh_96PnNbrBFkgn2SA',
          img: './static/image/mobilebanner02.png'
        }
      ],
      // 动画部分
      animate: {
        part1: {
          img: true,
          h2: true,
          p: true
        },
        part2: {
          img: false,
          h2: false,
          p: false
        },
        part3: {
          img: false,
          h2: false,
          p: false
        },
        part4: {
          img: false,
          h2: false,
          p: false
        },
        arr: [],
        seen: null
      },
      ToggleDevice: false,
      mobileHeight: 0,
      swiperOption: {
        autoplay: {
          disableOnInteraction: false
        },
        speed: 1500,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  mounted () {
    if (localStorage.getItem('ToggleDevice') === 'desktop') {
      window.addEventListener('scroll', this.handleScroll)
      this.seen = document.documentElement.clientHeight
      let arrcopy = []
      arrcopy[0] = document.querySelector('.part2').offsetTop
      arrcopy[1] = document.querySelector('.part3').offsetTop
      arrcopy[2] = document.querySelector('.part4').offsetTop
      arrcopy[3] = document.querySelector('.part1').offsetTop
      this.arr = arrcopy
      window.scrollTo(0, 0)
    }
  },
  created () {
    if (localStorage.getItem('ToggleDevice') !== 'desktop') {
      for (let i = 0; i < 4; i++) {
        this.animate['part' + (i + 1)].img = this.animate['part' + (i + 1)].h2 = this.animate['part' + (i + 1)].p = true
      }
      this.ToggleDevice = true
    } else {
      this.ToggleDevice = false
    }
  },
  computed: {
    bannerList: function () {
      return this.getMobileOrDesk()
    }
  },
  methods: {
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop + this.seen - this.arr[3] > 200) {
        this.animate.part1.img = true
        let that = this
        setTimeout(function () {
          that.animate.part1.h2 = true
        }, 700)
        setTimeout(function () {
          that.animate.part1.p = true
        }, 1000)
      }
      if (scrollTop + this.seen - this.arr[0] > 400) {
        this.animate.part2.img = true
        let that = this
        setTimeout(function () {
          that.animate.part2.h2 = true
        }, 700)
        setTimeout(function () {
          that.animate.part2.p = true
        }, 1000)
      }
      if (scrollTop + this.seen - this.arr[1] > 400) {
        this.animate.part3.img = true
        let that = this
        setTimeout(function () {
          that.animate.part3.h2 = true
        }, 700)
        setTimeout(function () {
          that.animate.part3.p = true
        }, 1000)
      }
      if (scrollTop + this.seen - this.arr[2] > 400) {
        this.animate.part4.img = true
        let that = this
        setTimeout(function () {
          that.animate.part4.h2 = true
        }, 700)
        setTimeout(function () {
          that.animate.part4.p = true
        }, 1000)
      }
    },
    signIn () {
      window.open('http://lh.playhudong.com/#/register')
    },
    /**
     * 判断是移动端还是桌面版
     */
    getMobileOrDesk () {
      if (localStorage.getItem('ToggleDevice') === 'desktop') {
        return this.bannerDesk
      } else {
        return this.bannerMobile
      }
    }
  }
}
</script>
<style lang="less">
.lh-main-container {
  background-color: white;
}
.lrtotal {
  height: 530px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    height: auto;
    display: block;
    text-align: center;
    padding: 30px 20px;
    p{
      text-align: justify;
    }
  }
  img {
    width: 527px;
    @media screen and (max-width: 768px) {
      width: 150px;
      margin-bottom: 20px;
      margin-right: 10px;
      margin-top: 20px;
    }
  }
}
.pub-height {
  height: 600px;
  @media screen and (max-width: 768px) {
    height: auto;
  }
}
.bg1 {
  background-color: #f8fcff;
  overflow: hidden;
  height: 646px;
}
.bg {
  background-color: #f8fcff;
  height: 600px;
}
.ltotal {
  width: 420px;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-right: 10px;
  }
}

.ltxt1 {
  font-size: 30px;
  color: #17203c;
  letter-spacing: 1.8px;
  font-weight: 400;
}
.flr {
  float: right;
  @media screen and (max-width: 768px) {
    float: none;
  }
}

.ltxt2 {
  font-size: 14px;
  color: #47536e;
  margin-top: 20px;
  letter-spacing: 1.8px;
}
.pub-ltxt1 {
  font-size: 18px;
  color: #47536e;
  margin-bottom: 20px;
  letter-spacing: 1.8px;
}
.pub-ltxt2 {
  font-size: 14px;
  color: #47536e;
  letter-spacing: 1.8px;
  height: 48px;
  @media screen and(max-width:768px) {
    height: auto;
  }
}
.banner {
  position: relative;
  overflow: hidden;
  width: 100%;
  img {
    width: 100%;
  }
}
.ltotal span {
  color: white;
}
.banner-bottom {
  height: 167px;
  position: relative;
  margin-top: -50px;
}
.svg {
  display: block;
  position: absolute;
  bottom: 0;
}
.headline {
  width: 100%;
  text-align: center;
  position: relative;
  height: 90px;
  overflow: hidden;
}
.lh-introduct {
  font-size: 22px;
  color: #1e2c4d;
  background-color: white;
  margin-top: 30px;
  letter-spacing: 1.8px;
}
.lh-introduct:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -34px;
  display: block;
  width: 68px;
  height: 3px;
  background-color: #4993ff;
}
.applyImg {
  margin-left: 20px;
  opacity: 1;
  position: relative;
}
.fade-enter-active {
  transition: all 2s;
}
.fade-enter {
  opacity: 0;
  transform: translateY(100px);
}
.part1 {
  background-color: white;
  overflow: hidden;
  height: 580px;
  @media screen and (max-width: 768px) {
    height: auto;
    padding: 20px 0;
  }
}
.part2,
.part3,
.part4 {
  height: 600px;
  width: 100%;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    height: auto;
    padding: 20px 0;
  }
}
.ml20 {
  margin-left: 20px;
  @media screen and(max-width: 768px) {
    margin-left: 0;
  }
}
.mr20 {
  margin-right: 20px;
  @media screen and(max-width: 768px) {
    margin-right: 0;
  }
}
#app .signInButton {
  margin-top: 30px;
  width: 120px;
  box-shadow: 0px 0px 15px rgba(65, 131, 238, 0.6);
}
#app .signInButton:hover {
  background-color: #2a75ed;
  border: 1px solid #2a75ed;
}
</style>



// WEBPACK FOOTER //
// src/components/mainContainer.vue